import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getDate,textDott } from "../../../helpers/TimeDate";
import { FetchTransaction } from "../../../redux/actions/PlanAction";
import Loder from "../../loder";
function TransactionModal(props) {
  const dispatch = useDispatch();
  const transactions = useSelector((state) => state.PlanReducer.transactions);
  console.log(transactions)
    const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));

  useEffect(() => {
    dispatch(FetchTransaction());
  }, []);

  console.log(transactions)
  return (
    <>
      
          <h4 >Your Transactions</h4>
          <div>
            {transactions? transactions[0]? (
              transactions.map((data, i) => (

                <div className="card  mt-4" key={i}>
                  <div className="text-center">
                        <div className={data.status==="Pending"?"pending tag mx-auto":data.status==="Failed"?"faluare tag mx-auto":"success tag mx-auto"}>{data.status}</div>
                      </div>
                  <div className="row">
                    
                    <div className="col-6">
                      <div>
                        <p className="top mb-0">Date:</p>
                        <p className="bottom">{getDate(data.date)}</p>
                      </div>

                      <div>
                        <p className="top mb-0">Order id:</p>
                        <p className="bottom">{textDott(data.orderid,15)}</p>
                      </div>
                    </div>
                    <div className="col-6">
                      

                      <div>
                        <p className="top mb-0  ml-5">Plan:</p>
                        <p className="bottom ml-5">{data.txndescription}</p>
                      </div>
                      <div>
                        <p className="top mb-0  ml-5">Amount:</p>
                        <p className="bottom ml-5">{data.currency === "USD"? `${data.currency} ${data.amount/100}`: `${data.currency} ${data.amount}`} </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ): <div className="text-center">Transaction Histoty not available</div> : (
              <Loder />
            )}
          </div>
        
    </>
  );
}

export default TransactionModal;
